// extracted by mini-css-extract-plugin
export var alignBaseline = "_p-9";
export var alignCenter = "_p-5";
export var alignFlexEnd = "_p-7";
export var alignFlexStart = "_p-6";
export var alignSelfBaseline = "_p-e";
export var alignSelfCenter = "_p-a";
export var alignSelfFlexEnd = "_p-c";
export var alignSelfFlexStart = "_p-b";
export var alignSelfStretch = "_p-d";
export var alignStretch = "_p-8";
export var column = "_p-2";
export var columnReverse = "_p-4";
export var flex = "_p-0";
export var justifyCenter = "_p-f";
export var justifyFlexEnd = "_p-h";
export var justifyFlexStart = "_p-g";
export var justifySpaceAround = "_p-j";
export var justifySpaceBetween = "_p-i";
export var justifySpaceEvenly = "_p-k";
export var row = "_p-1";
export var rowReverse = "_p-3";
export var wrapNowrap = "_p-m";
export var wrapWrap = "_p-l";
export var wrapWrapReverse = "_p-n";